/* Perfil del usuario, llamado desde en encabezado del sitio, abre en ventana */

//*react- recursos
  import { useEffect } from "react";
  import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
  import { faEnvelope, faPhone } from "@fortawesome/free-solid-svg-icons";

//*clases
  import "./encabezado.css";
  //iconos
  import { AiOutlineApartment } from "react-icons/ai";
  import { AiOutlineClose } from "react-icons/ai";


//*archivos (imagenes y elementos necesarios para la rutina)
  import usuario from "../../../imagenes/user-icon.png";

//datos (json)
  import Etiquetas from "../../../datos/json/etiquetasSSC.json";
  import Roles from "../../../datos/json/roles.json";

//*api's (servicios y store)
  import usersServicio from "../../../api/recursos/users/users.servicio";
  import usersStore from "../../../api/recursos/users/users.store";

  import { MdManageAccounts } from "react-icons/md";
//*store's

//*funciones

//* interface (parametros de entrada)
  interface PropsPerfil {
    tokenStore:any;
    usuarioStore: any;
    rolsStore:any
  }

//*componente
  export default function PerfilUsuario(props: PropsPerfil) {
    
    //*api store
      const { guardaGetUserAuthStore, getUserAuthStore,
              generaobjErrorUsersStore} = 
        usersStore((state: any) => ({
          guardaGetUserAuthStore: state.guardaGetUserAuthStore,
          getUserAuthStore: state.getUserAuthStore,
          generaobjErrorUsersStore: state.generaobjErrorUsersStore
      }));

    //*store's
    //*datos
    //*constantes y variables
    //*usestate

    //*useEffect
      useEffect(() => {
        //carga los datos del usuario
        usersServicio
          .cargaGetUserAuth(props.tokenStore)
            .then((response: any) => {
              if (response.status == 200) { 
                  guardaGetUserAuthStore(response); //va a store a guardar información
                  //console.log(getUserAuthStore, "getUserAuthStore.....");
              }
            })
            .catch((ex) => {
              console.log("--catch - ex (cargaGetAllOrigin): ", ex);
              generaobjErrorUsersStore(ex.response, true, "", "", "PerfilUsuario",'E');
            });
      }, []);

    return (
      <>
        {/* primaryBtn   oscurece*/}
        <div className="container" id="perfil2" style={{zIndex:"3000"}}>
          <div className="row">         
            <div className="col centrar "><img src={usuario} alt="Usuario" className="profile-img" /></div>
          </div><br />
          <div className="row">          
            <div className="col centrar title_perfil3 font-weight-bolder">{getUserAuthStore.name}</div>            
          </div>
          <div className="row">           
            <div className="col centrar"> {Etiquetas.PerfilDelUsuario.etiquetas[0].text}</div>         
          </div><br />
          <div className="row">
            <div className="col-3 "><FontAwesomeIcon
                      icon={faEnvelope}                      
                      className="colorBlue1"
                      fontSize={20}
                    />&nbsp;{Etiquetas.PerfilDelUsuario.etiquetas[1].text}</div>
            <div className="col-3 colorBlue1"> {getUserAuthStore.email}</div>
            <div className="col-3"></div>
          </div><br />
          <div className="row">
            <div className="col-3"><FontAwesomeIcon
                      icon={faPhone}
                      rotation={90}
                      className="colorBlue1"
                      fontSize={20}
                    />
                    &nbsp;{Etiquetas.PerfilDelUsuario.etiquetas[2].text}&nbsp;</div>
            <div className="col-3"> <span className="colorBlue1 smaller ">
                      {" "}
                      {getUserAuthStore.phoneNumber}
                    </span>{" "}
                    Ext:
                    <span className="colorBlue1 smaller ">
                      {" "}
                      {getUserAuthStore.ext}
                    </span></div>
            <div className="col"></div>
          </div><br />
          <div className="row">
            <div className="col-3"><AiOutlineApartment className="colorBlue1" size={25}/>
                    &nbsp;{Etiquetas.PerfilDelUsuario.etiquetas[3].text}
                    <br /></div>
            <div className="col-5"> <span className="colorBlue1 ">
                      {getUserAuthStore.areaName}  - &nbsp; 
                      {getUserAuthStore.departament}&nbsp; 
                    </span></div>
            <div className="col"></div>
          </div>
          <br />
          <div className="row">
            <div className="col-3"><MdManageAccounts  className="colorBlue1" size={25}/>
                    &nbsp;{Etiquetas.PerfilDelUsuario.etiquetas[4].text}
                    
            </div>
            <div className="col-5 colorBlue1 ">{Roles.roles.map((data, key) => {
                      console.log(key);
                      console.log(data.desc);
                      for (var i = 0; i < props.rolsStore.length; i++) {
                        if (props.rolsStore[i] === key) {
                          console.log(data.desc);
                          return (
                            <div
                              style={{
                                width: "100% !important",
                                display: "flex",
                                position: "relative",
                              }}
                              key={key}
                            >
                              {data.desc}
                            </div>
                          );
                        }
                      }
            })}</div>
            <div className="col"></div>
          </div><br />
          {/* <div className="row">
            <div className="col-3 title_perfil3 font-weight-bolder text-left">{Etiquetas.PerfilDelUsuario.etiquetas[4].text}dddd </div>
            <div className="col-5 colorBlue1 width-100">{Roles.roles.map((data, key) => {
                      console.log(key);
                      console.log(data.desc);
                      for (var i = 0; i < props.rolsStore.length; i++) {
                        if (props.rolsStore[i] === key) {
                          console.log(data.desc);
                          return (
                            <div
                              style={{
                                width: "100% !important",
                                display: "flex",
                                position: "relative",
                              }}
                              key={key}
                            >
                              {data.desc}
                            </div>
                          );
                        }
                      }
                    })}</div>
            <div className="col">ddddd</div>
          </div> */}
          {/* <div className="row">            
            <div className="col-5 colorBlue1 width-100">{Roles.roles.map((data, key) => {
                      console.log(key);
                      console.log(data.desc);
                      for (var i = 0; i < props.rolsStore.length; i++) {
                        if (props.rolsStore[i] === key) {
                          console.log(data.desc);
                          return (
                            <div
                              style={{
                                width: "100% !important",
                                display: "flex",
                                position: "relative",
                              }}
                              key={key}
                            >
                              {data.desc}
                            </div>
                          );
                        }
                      }
                    })}</div>
            <div className="col"></div>        
            <div className="col"></div>
          </div> */}
        </div>
        <br/><br/><br/><br/>
        {/* <div className="pull-right border " id="perfil">
          <div className="izq ">
            <AiOutlineClose />
          </div>
          <div className="row">
            <div className="col-lg-3 col-sm-12">
              <div className="card_perfil hovercard">
                <div className="cardheader"></div>
                <div className="avatar offset-11">
                  <img src={usuario} alt="Usuario" className="profile-img" />
                </div>
                <div className="info small">
                  <div className="title_perfil3 font-weight-bolder ">
                    {getUserAuthStore.name}
                  </div>
                  <div className="title_perfil small text-center">
                    {Etiquetas.PerfilDelUsuario.etiquetas[0].text}
                  </div>
                  <hr className="title_perfil " />
                  <div className="title_perfil ">
                    <FontAwesomeIcon
                      icon={faEnvelope}
                      style={{ fontSize: 15 }}
                      className="colorBlue1"
                    />
                    &nbsp;{Etiquetas.PerfilDelUsuario.etiquetas[1].text}
                  </div>
                  <div className="title_perfil3 text-left colorBlue1 ">
                    {getUserAuthStore.email}
                  </div>
                  <br />
                  <div className="title_perfil">
                    <FontAwesomeIcon
                      icon={faPhone}
                      rotation={90}
                      className="colorBlue1"
                    />
                    &nbsp;{Etiquetas.PerfilDelUsuario.etiquetas[2].text}&nbsp;
                    <span className="colorBlue1 smaller ">
                      {" "}
                      {getUserAuthStore.phoneNumber}ddd
                    </span>{" "}
                    Ext:
                    <span className="colorBlue1 smaller ">
                      {" "}
                      {getUserAuthStore.ext}
                    </span>
                  </div>
                  <div className="title_perfil"></div>
                  <br />
                  <div className="title_perfil ">
                    <AiOutlineApartment className="colorBlue1" />
                    &nbsp;{Etiquetas.PerfilDelUsuario.etiquetas[3].text}
                    <br />
                    <span className="colorBlue1 ">
                      {getUserAuthStore.areaName}- &nbsp;
                      {getUserAuthStore.departament}&nbsp;
                    </span>
                  </div>

                  <hr className="title_perfil" />
                  <div className="title_perfil3 font-weight-bolder text-left  ">
                    {Etiquetas.PerfilDelUsuario.etiquetas[4].text}rooool
                  </div>
                  <div
                    className="colorBlue1 width-100"
                    style={{ position: "absolute" }}
                  >
                    {Roles.roles.map((data, key) => {
                      console.log(key);
                      console.log(data.desc);
                      for (var i = 0; i < props.rolsStore.length; i++) {
                        if (props.rolsStore[i] === key) {
                          console.log(data.desc);
                          return (
                            <div
                              style={{
                                width: "100% !important",
                                display: "flex",
                                position: "relative",
                              }}
                              key={key}
                            >
                              {data.desc}
                            </div>
                          );
                        }
                      }
                    })}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div> */}
      </>
    );
  }
